import React from "react";

import { FaPhone, FaEnvelope, FaQuestionCircle } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
const ContactUs = () => {
  return (
    <div className="page-content">
    <div className="contact-us-page">
      {/* Header Section */}
   <section className="contact-header ">   
      <div className="container text-center ">
     
        <h1>Contact Us</h1>
        <p>
          Please reach out to us if you have any questions regarding sales,
          support, or general questions.
        </p>
       
      </div>
       </section> 

      {/* Contact Options */}
      <section className="contact-options  ">
        <div className="container">
        <div className="row text-center py-5">
          <div className="col-md-4">
            <div className="contact-card">
              <FaLocationDot className="contact-icon" />
              <h3>Location</h3>
              <p>
              A 87, Sector 69, Noida, Uttar Pradesh -201301
              </p>
             
            </div>
          </div>
          <div className="col-md-4">
            <div className="contact-card">
              <FaPhone  className="contact-icon" />
              <h3>Call Us</h3>
              <p>
              +91 77018 85426
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="contact-card">
              <FaEnvelope className="contact-icon" />
              <h3>Mail Us</h3>
              <p>
              info@integratedinterior.com
              </p>
             
            </div>
          </div>
        </div>
        </div>
      </section>


      {/* Contact Form and Info Section */}
      <section className="contact-form-section py-5 container">
        <div className="row">
          <div className="col-md-5">
            <h3>Contact Us</h3>
            <p>
              Please fill out the information and we will get back to you
              within 1-2 business days.
            </p>
            <form action="https://formspree.io/f/xovlvpjv"
  method="POST">
              <input
                type="text"
                name="name"
                className="form-control mb-3"
                placeholder="Full Name"
              />
              <input
                type="email"
                name="email"
                className="form-control mb-3"
                placeholder="Email Address"
              />
              <input 
                type="tel"
                name="phone"
                className="form-control mb-3"
                placeholder="Phone Number"
              />
              <input
                type="text"
                name="subject"
                className="form-control mb-3"
                placeholder="Subject"
              />
              <textarea
                className="form-control mb-3"
                rows="4"
                name="message"
                placeholder="Message"
              ></textarea>
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </form>
          </div>
          <div className="col-md-1"></div>
          <div className="col-md-6">
            <h3>How can we help?</h3>
            <ul className="help-list">
              <li>
                <strong>Book a Free Consultation:</strong>  Reach out to us for a personalized consultation to discuss your interior design needs.
              </li>
              <li>
                <strong>Get Expert Advice:</strong> Chat with our experienced designers to explore ideas for your home, office, or shop interiors.
              </li>
              <li>
                <strong>Partner With Us:</strong> Interested in collaborating on interior projects? Let’s build something amazing together.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
    </div>
  );
};

export default ContactUs;
